import * as Types from '../graphql.generated';

export type DeleteTrackedPropertyPermissionsMutationVariables = Types.Exact<{
    uprn: Types.Scalars['String'];
}>;

export type DeleteTrackedPropertyPermissionsMutation = {
    __typename?: 'Mutation';
} & Pick<Types.Mutation, 'deleteTrackedPropertyPermissions'>;

export const DeleteTrackedPropertyPermissionsDocument = `
    mutation deleteTrackedPropertyPermissions($uprn: String!) {
  deleteTrackedPropertyPermissions(uprn: $uprn)
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        deleteTrackedPropertyPermissions(
            variables: DeleteTrackedPropertyPermissionsMutationVariables,
            options?: C
        ): Promise<DeleteTrackedPropertyPermissionsMutation> {
            return requester<
                DeleteTrackedPropertyPermissionsMutation,
                DeleteTrackedPropertyPermissionsMutationVariables
            >(DeleteTrackedPropertyPermissionsDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
